module.exports = __webpack_public_path__ + "static/day_split_timeslots-a8d01dcc406fa302af79dc7560aa4ffa.png";